import { useNavigation } from '@remix-run/react'
import { useEffect, useRef, useState } from 'react'
import { useSpinDelay } from 'spin-delay'
import { cn } from '#app/utils/misc.tsx'
import { Icon } from './ui/icon.tsx'

function EpicProgress() {
	const transition = useNavigation()
	const busy = transition.state !== 'idle'
	const delayedPending = useSpinDelay(busy, {
		delay: 600,
		minDuration: 400,
	})
	const ref = useRef<HTMLDivElement>(null)
	const [animationComplete, setAnimationComplete] = useState(true)

	useEffect(() => {
		if (!ref.current) return
		if (delayedPending) setAnimationComplete(false)

		const animationPromises = ref.current
			.getAnimations()
			.map(({ finished }) => finished)

		Promise.allSettled(animationPromises).then(() => {
			if (!delayedPending) setAnimationComplete(true)
		})
	}, [delayedPending])

	return (
		<>
			<div
				role="progressbar"
				aria-hidden={delayedPending ? undefined : true}
				aria-valuetext={delayedPending ? 'Loading' : undefined}
				className="fixed inset-x-0 left-0 top-0 z-50 h-1 animate-pulse"
			>
				<div
					ref={ref}
					className={cn(
						'h-full w-0 bg-gradient-to-r from-iagtDarkBlue via-blue-500 to-iagtDarkBlue shadow-lg shadow-blue-500/50 duration-500 ease-in-out',
						transition.state === 'idle' &&
							(animationComplete
								? 'transition-none'
								: 'w-full opacity-0 transition-all'),
						delayedPending && transition.state === 'submitting' && 'w-5/12',
						delayedPending && transition.state === 'loading' && 'w-8/12',
					)}
				/>
			</div>

			{delayedPending && (
				<>
					<div className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm transition-opacity duration-300" />
					<div className="fixed left-1/2 top-1/2 z-50 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-background/90 p-4 shadow-xl">
						<Icon
							name="update"
							size="xl"
							className="animate-spin text-iagtDarkBlue"
							aria-hidden
						/>
					</div>
				</>
			)}
		</>
	)
}

export { EpicProgress }
